"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDropDown = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M21 31.71v9.07h42.09v-9.07zm39.5 6.44H23.59v-3.8h36.86zM21 51.31h42.09v-9.06H21zm2.64-6.44h36.81v3.81H23.59zM21 61.78h42.09v-9.07H21zm2.64-6.44h36.81v3.8H23.59zm25.16-26.7h11.36v-15.8H6.62v15.8zm0-13.17h8.78V26h-8.83zM9.25 26V15.47h36.87V26zm41.18-6.54h5.77l-2.88 3.67zm0 0"
  })),
  height: undefined,
  width: undefined
});
IconDropDown.displayName = 'IconDropDown';
var _default = IconDropDown;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/drop-down.js
// module id = 569
// module chunks = 0